import { makeSelectors } from '@utils/css';
import { aspectCls, boundaryCls } from './atoms/styles/Boundary.js';

const CROSSFADE_DURATION_MS = 150;
const containerCls = "gfxciigt9k";
const contentCls = "gfxc4ppgy1";
const imgCls = "gfxi62k2s1";
const preloaderCls = "gfxplr8c46";
const errorMessageCls = "gfxe1dwdjfz";
const errorText = "gfxeb7wzeb";
const publisherLogo = "gfxp17wad8q";
const imageSelectors = makeSelectors({
  boundary: boundaryCls,
  aspect: aspectCls
});

export { CROSSFADE_DURATION_MS, containerCls, contentCls, errorMessageCls, errorText, imageSelectors, imgCls, preloaderCls, publisherLogo };
import "./image.style.linaria.module.css";
//# sourceMappingURL=image.style.js.map
